var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQuickFileManagement(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    fill: "#99e6fc"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m232.661 248.5h58.75v15h-58.75z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m176.377 179.649v-63.455c0-4.385 3.567-7.952 7.953-7.952h107.081v-15h-107.081c-12.656 0-22.953 10.296-22.953 22.952v63.455z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m291.411 403.758h-107.081c-4.385 0-7.953-3.567-7.953-7.952v-54.914h-15v54.914c0 12.656 10.296 22.952 22.953 22.952h107.081z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m116.696 179.679-17.402-33.281c-2.665-5.097-7.942-8.293-13.694-8.293h-75.298c-5.69 0-10.302 4.613-10.302 10.302v31.272z",
    fill: "#ffc344"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m99.294 146.398c-2.665-5.097-7.942-8.293-13.694-8.293h-32.45c5.752 0 11.028 3.195 13.694 8.293l17.402 33.281h32.451z",
    fill: "#feb237"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m223.359 341.892h-213.057c-5.69 0-10.302-4.613-10.302-10.302v-152.941h223.359c5.69 0 10.302 4.612 10.302 10.302v142.639c0 5.689-4.613 10.302-10.302 10.302z",
    fill: "#ffd15b"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m223.359 178.649h-32.26c5.69 0 10.302 4.612 10.302 10.302v142.639c0 5.69-4.612 10.302-10.302 10.302h32.26c5.69 0 10.302-4.612 10.302-10.302v-142.639c0-5.69-4.613-10.302-10.302-10.302z",
    fill: "#ffc344"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m501.698 143.72h-200.986c-5.69 0-10.302-4.612-10.302-10.302v-71.092c0-5.69 4.612-10.302 10.302-10.302h200.986c5.69 0 10.302 4.612 10.302 10.302v71.092c0 5.69-4.612 10.302-10.302 10.302z",
    fill: "#dff6fd"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m501.698 52.024h-32.35c5.69 0 10.302 4.612 10.302 10.302v71.092c0 5.69-4.612 10.302-10.302 10.302h32.35c5.69 0 10.302-4.612 10.302-10.302v-71.092c0-5.69-4.612-10.302-10.302-10.302z",
    fill: "#c8effe"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m483.245 119.271h-98.902c-4.142 0-7.5-3.357-7.5-7.5s3.358-7.5 7.5-7.5h98.902c4.142 0 7.5 3.357 7.5 7.5s-3.358 7.5-7.5 7.5z",
    fill: "#8ac9fe"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m483.245 91.474h-98.902c-4.142 0-7.5-3.357-7.5-7.5s3.358-7.5 7.5-7.5h98.902c4.142 0 7.5 3.357 7.5 7.5s-3.358 7.5-7.5 7.5z",
    fill: "#8ac9fe"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 337.057,
    cy: 97.872,
    fill: "#05e39c",
    r: 22.5
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m337.057 75.372c-3.754 0-7.285.932-10.397 2.558 7.189 3.756 12.103 11.27 12.103 19.942 0 8.673-4.914 16.187-12.103 19.942 3.112 1.626 6.643 2.557 10.397 2.557 12.426 0 22.5-10.074 22.5-22.5 0-12.425-10.073-22.499-22.5-22.499z",
    fill: "#0ed290"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m501.698 301.848h-200.986c-5.69 0-10.302-4.612-10.302-10.302v-71.092c0-5.69 4.612-10.302 10.302-10.302h200.986c5.69 0 10.302 4.612 10.302 10.302v71.092c0 5.69-4.612 10.302-10.302 10.302z",
    fill: "#dff6fd"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m501.698 210.152h-32.35c5.69 0 10.302 4.612 10.302 10.302v71.093c0 5.689-4.612 10.302-10.302 10.302h32.35c5.69 0 10.302-4.612 10.302-10.302v-71.093c0-5.69-4.612-10.302-10.302-10.302z",
    fill: "#c8effe"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m483.245 277.398h-98.902c-4.142 0-7.5-3.357-7.5-7.5s3.358-7.5 7.5-7.5h98.902c4.142 0 7.5 3.357 7.5 7.5s-3.358 7.5-7.5 7.5z",
    fill: "#8ac9fe"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m401.255 249.602h-16.912c-4.142 0-7.5-3.357-7.5-7.5s3.358-7.5 7.5-7.5h16.912c4.142 0 7.5 3.357 7.5 7.5s-3.358 7.5-7.5 7.5z",
    fill: "#8ac9fe"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m483.245 249.602h-59.326c-4.142 0-7.5-3.357-7.5-7.5s3.358-7.5 7.5-7.5h59.326c4.142 0 7.5 3.357 7.5 7.5s-3.358 7.5-7.5 7.5z",
    fill: "#8ac9fe"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 337.057,
    cy: 256,
    fill: "#05e39c",
    r: 22.5
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m337.057 233.5c-3.754 0-7.285.932-10.397 2.558 7.189 3.756 12.103 11.27 12.103 19.942 0 8.673-4.914 16.187-12.103 19.942 3.112 1.626 6.643 2.557 10.397 2.557 12.426 0 22.5-10.074 22.5-22.5 0-12.425-10.073-22.499-22.5-22.499z",
    fill: "#0ed290"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m501.698 459.976h-200.986c-5.69 0-10.302-4.612-10.302-10.302v-71.092c0-5.69 4.612-10.302 10.302-10.302h200.986c5.69 0 10.302 4.612 10.302 10.302v71.092c0 5.69-4.612 10.302-10.302 10.302z",
    fill: "#dff6fd"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m501.698 368.28h-32.35c5.69 0 10.302 4.612 10.302 10.302v71.093c0 5.69-4.612 10.302-10.302 10.302h32.35c5.69 0 10.302-4.612 10.302-10.302v-71.093c0-5.69-4.612-10.302-10.302-10.302z",
    fill: "#c8effe"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m483.245 435.526h-12.967c-4.142 0-7.5-3.357-7.5-7.5s3.358-7.5 7.5-7.5h12.967c4.142 0 7.5 3.357 7.5 7.5s-3.358 7.5-7.5 7.5z",
    fill: "#8ac9fe"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m447.614 435.526h-63.271c-4.142 0-7.5-3.357-7.5-7.5s3.358-7.5 7.5-7.5h63.271c4.142 0 7.5 3.357 7.5 7.5s-3.358 7.5-7.5 7.5z",
    fill: "#8ac9fe"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m483.245 407.729h-98.902c-4.142 0-7.5-3.357-7.5-7.5s3.358-7.5 7.5-7.5h98.902c4.142 0 7.5 3.357 7.5 7.5s-3.358 7.5-7.5 7.5z",
    fill: "#8ac9fe"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 337.057,
    cy: 414.128,
    fill: "#05e39c",
    r: 22.5
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m337.057 391.628c-3.754 0-7.285.932-10.397 2.558 7.189 3.756 12.103 11.27 12.103 19.942 0 8.673-4.914 16.187-12.103 19.942 3.112 1.626 6.643 2.557 10.397 2.557 12.426 0 22.5-10.074 22.5-22.5s-10.073-22.499-22.5-22.499z",
    fill: "#0ed290"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuickFileManagement);
export default __webpack_public_path__ + "static/media/quick-file-management.e68f586556e7168ca276ebdd77ad64cf.svg";
export { ForwardRef as ReactComponent };